import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ResultInfo from "components/atoms/ResultInfo";

const ResultHead = (props) => {
  const { resultInfo, className } = props;
  const componentClassName = "sal-result-head";
  const componentClass = classnames(componentClassName, className);
  return (
    <div className={componentClass}>
      <ResultInfo {...resultInfo} />
    </div>
  );
};

ResultHead.propTypes = {
  resultInfo: PropTypes.shape({
    count: PropTypes.number.isRequired,
    resultsText: PropTypes.string,
    resultText: PropTypes.string,
    preposition: PropTypes.string,
    searchTerm: PropTypes.string,
  }).isRequired,
  filterInfo: PropTypes.shape({
    className: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};
export default ResultHead;
